export default function() {
  return {
    orders: {},
    detail: {},
    reasons: null,
  }
}
